/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import LinearProgress from "@mui/material/LinearProgress";
import { LoaderWrapper } from "./loader-wrapper.jsx";
import { StageLogin } from "./stage-login.jsx";
import { CmsConfig } from "cms/config.js";

const TopEdgeLoader = () => {

    const isStage = CmsConfig.isStage;

    return (
        <LoaderWrapper>
            <LinearProgress color="primary" />
            {isStage &&
                <StageLogin />
            }
        </LoaderWrapper>
    );
};

export { TopEdgeLoader };
